/**
 * Crea un efecto visual equivalente a filter:blur(100px) usando Canvas.
 * Compatible con televisores y navegadores antiguos.
 *
 * Por qué esta técnica:
 * - filter:blur(100px) en un elemento de ~68px de alto desvanece casi toda la
 *   opacidad porque el kernel de blur (100px) supera la altura del elemento,
 *   haciendo que la mayoría de los píxeles muestreen fuera del área y obtengan
 *   alpha=0. El resultado es un halo de color muy tenue y oscuro.
 * - Replicamos ese resultado dibujando el gradiente con colores ya desvanecidos
 */
export const createBlurCanvas = function() {
    const canvas = document.createElement('canvas');
    canvas.width  = 100;
    canvas.height = 20;

    const ctx = canvas.getContext('2d');

    // 1. Gradiente horizontal de colores
    const hGradient = ctx.createLinearGradient(0, 0, 100, 0);
    hGradient.addColorStop(0,      'rgba(100, 121, 255, 0.0)');
    hGradient.addColorStop(0.15,   'rgba(100, 121, 255, 0.15)');
    hGradient.addColorStop(0.3413, 'rgba(100, 121, 255, 0.22)');
    hGradient.addColorStop(0.7404, 'rgba(255,  13,   0, 0.22)');
    hGradient.addColorStop(0.85,   'rgba(255,  13,   0, 0.15)');
    hGradient.addColorStop(1,      'rgba(255,  13,   0, 0.0)');

    ctx.fillStyle = hGradient;
    ctx.fillRect(0, 0, 100, 20);

    // 2. Máscara vertical: opaco arriba → transparente abajo
    // usando destination-in para que el fade recorte el color horizontal
    ctx.globalCompositeOperation = 'destination-in';
    const vGradient = ctx.createLinearGradient(0, 0, 0, 20);
    vGradient.addColorStop(0,    'rgba(0, 0, 0, 1)');
    vGradient.addColorStop(0.4,  'rgba(0, 0, 0, 0.85)');
    vGradient.addColorStop(1,    'rgba(0, 0, 0, 0)');

    ctx.fillStyle = vGradient;
    ctx.fillRect(0, 0, 100, 20);
    ctx.globalCompositeOperation = 'source-over';
    ctx.imageSmoothingEnabled = true;


    canvas.style.position = 'absolute';
    canvas.style.top      = '0';
    canvas.style.left     = '-185px';
    canvas.style.width    = '700px';
    canvas.style.height   = '160px';
    canvas.style.zIndex   = '-1';

    return canvas;
};




// WEBPACK FOOTER //
// ./src/components/centerNotification/blurCanvas.js